<script lang="ts">
import { lateinit } from 'tg-commons'
import { ControlPosition, type MapTypeControl, type MapTypeControlOptions, MapTypeControlType, unwrapStringEnumValue, type WrapStringEnumValue } from 'tg-map-core'
import { defineComponent } from 'vue'
import { optionalProp, type Props, stringEnumProp } from '../../utils/vue-utils'
import MapMixin from '../map-mixin'

export default defineComponent({
  name: 'tg-map-type-control',
  mixins: [MapMixin],
  props: {
    position: stringEnumProp(ControlPosition, ControlPosition.TOP_LEFT),
    type: stringEnumProp(MapTypeControlType),
    mapTypes: optionalProp(Array as any),
  } satisfies Props<WrapStringEnumValue<MapTypeControlOptions, {
    position: typeof ControlPosition,
    type: typeof MapTypeControlType
  }>>,
  setup() {
    return {
      control: lateinit<MapTypeControl>(),
    }
  },
  watch: {
    position(value) {
      this.control.setPosition(value)
    },
    type() {
      this.recreate()
    },
    mapTypes: {
      handler() {
        this.recreate()
      },
      deep: true,
    },
  },
  onCreate() {
    this.control = this.$map.createMapTypeControl(unwrapStringEnumValue(this))
    this.$map.addControl(this.control)
  },
  onDestroy() {
    this.$map.removeControl(this.control)
  },
})

</script>
